import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgUpload = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.25a.75.75 0 0 1 .557.248l4.5 5a.75.75 0 1 1-1.114 1.004L12.75 5.954V16a.75.75 0 0 1-1.5 0V5.954L8.057 9.502a.75.75 0 1 1-1.114-1.004l4.5-5A.75.75 0 0 1 12 3.25m-9 13.5a.75.75 0 0 1 .75.75V20c0 .138.112.25.25.25h16a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0V20A1.75 1.75 0 0 1 20 21.75H4A1.75 1.75 0 0 1 2.25 20v-2.5a.75.75 0 0 1 .75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgUpload;
